import { Outlet, Navigate } from "react-router-dom";
import { PERMISOS, RolesUsuarios } from "../useAuth/useAuth";

interface childsProps {
  rolUsuario: RolesUsuarios;
  permisos: PERMISOS[];
}
//Ruta protegida para que solo los conductores puedan liquidar una ruta
const TienePermisos: React.FC<childsProps> = ({rolUsuario, permisos}) => {  
  switch(rolUsuario){
    case RolesUsuarios.CONDUCTOR:
      if(permisos.includes(PERMISOS.PUEDE_LIQUIDAR_RUTA)){
        return <Outlet />;
      }
      break;
    case RolesUsuarios.COMUN:
      if (permisos.includes(PERMISOS.GENERAL)) {
        return <Outlet/>
      }
      break;
    default:
      return <Navigate to="home" />
  } 


  return <Navigate to="home" />
};

export default TienePermisos;